import React from 'react';

const PageHeader = ({ title, subtitle, bgImage = false }) => {
  return (
    <section className={`py-16 px-6 ${bgImage ? 'bg-gradient-to-r from-netbernet-blue to-netbernet-black' : 'bg-netbernet-blue'} text-netbernet-white`}>
      <div className="container mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>
        {subtitle && <p className="text-xl max-w-3xl mx-auto">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHeader;